module.exports = __webpack_public_path__ + "static/media/logo_ot.1ca02ffb.png";